/* tslint:disable */
/* eslint-disable */
/**
/* This file was automatically generated from pydantic models by running pydantic2ts.
/* Do not modify it by hand - just update the pydantic models and then re-run the script
*/

export type InferenceLocations = 0 | 1;
export type EvaluationContentType = 0 | 1 | 2;
export type SeverityLevel = 0 | 1 | 2 | 3 | 4;

export interface Application {
  id?: number | null;
  date_created?: number | null;
  application_name?: string | null;
  application_ref_name?: string | null;
  company_id?: number;
  application_objective?: ApplicationObjective | null;
  state?: string | null;
  meta?: Config | null;
  action_types?: ApplicationAction[];
  last_activity?: number | null;
  fault_notifications?: boolean | null;
  session_summaries?: boolean | null;
}
export interface ApplicationObjective {
  id?: number | null;
  date_created?: number | null;
  application_id: number;
  objective_body?: {
    [k: string]: string;
  };
  [k: string]: unknown;
}
export interface Config {
  inference_location?: InferenceLocations;
  evaluation_enabled?: boolean;
  apply_corrections?: boolean;
  model?: string;
  temperature?: number;
  streaming?: boolean;
  response_format?: string;
  stop?: string | string[] | null;
  logprobs?: boolean;
  max_tokens?: number | null;
  n?: number;
  presence_penalty?: number;
  frequency_penalty?: number;
  timeout?: number;
  context_retrieval_enabled?: boolean;
  fallback_model?: string | null;
  intent_stability?: string | null;
  safe_mode?: boolean;
  feedback?: string[];
  generating_sentinels?: boolean;
  sentinel_regeneration_enabled?: boolean;
  fallback_config?: FallbackConfig | null;
  extract_request_metadata?: boolean;
  metadata?: {
    [k: string]: unknown;
  };
  system_prompt?: string | null;
  reasoning_effort?: string | null;
  disable_session_update_events?: boolean | null;
}
export interface FallbackConfig {
  model?: string | null;
  strategy?: ("reactive" | "first_response" | "timeout") | string | null;
  timeout?: number | null;
  [k: string]: unknown;
}
export interface ApplicationAction {
  id?: number | null;
  action_type: string;
  date_created?: number | null;
  application_id: number;
  meta?: Config | null;
  last_activity?: number | null;
  notifications_enabled?: boolean;
  prompt?: string | null;
  request_count?: number | null;
  intent_group_id?: number | null;
  agent_id?: number | null;
  agent_name?: string | null;
}
export interface ChatCompletionRequest {
  params?: ChatCompletionParams;
  application_ref_name?: string;
  session_id?: string;
  action_type?: string;
  application_id?: number | null;
  reference_id?: string | number | null;
  application_action_id?: number | null;
  company_id?: number | null;
  apply_corrections?: boolean | null;
  id?: number | null;
  date_created?: number | null;
  request_id?: string | null;
  evaluation_enabled?: boolean | null;
  auth_info?: ChatCompletionAuth | null;
  return_evaluation?: boolean | null;
  error?: string | null;
  auth_keys?: KeyMap | null;
  inference_location?: string | null;
  context_retrieval_enabled?: boolean | null;
  context_query?: string | null;
  context?: string | null;
  return_request?: boolean | null;
  fallback_model?: string | null;
  user_id?: string | null;
  assistant?: boolean | null;
  client_params?: ClientParams | null;
  metadata?: {
    [k: string]: unknown;
  } | null;
  safe_mode?: boolean | null;
  preserve_model_alias?: boolean | null;
  fallback_config?: FallbackConfig | null;
  request_type?: "PROD" | "RERUN" | "SYNTHETIC" | "MANUAL";
}
export interface ChatCompletionParams {
  messages: ChatMessage[];
  model?: string | null;
  max_tokens?: number | null;
  response_format?: ResponseFormat | null;
  temperature?: number | null;
  top_p?: number | null;
  stop?: string | string[] | null;
  logprobs?: boolean | null;
  top_logprobs?: number | null;
  n?: number | null;
  seed?: number | null;
  stream?: boolean | null;
  stream_options?: StreamOptions | null;
  logit_bias?: {
    [k: string]: number;
  } | null;
  presence_penalty?: number | null;
  frequency_penalty?: number | null;
  user?: string | null;
  tools?: Tool[] | null;
  tool_choice?: ToolChoice | string | null;
  parallel_tool_calls?: boolean | null;
  extra_headers?: {
    [k: string]: string;
  } | null;
  reasoning_effort?: string | null;
  [k: string]: unknown;
}
export interface ChatMessage {
  role: string;
  content?:
    | string
    | {
        [k: string]: unknown;
      }[]
    | null;
  name?: string | null;
  tool_calls?: ToolCall[] | null;
  tool_call_id?: string | null;
  [k: string]: unknown;
}
export interface ToolCall {
  id?: string | null;
  type?: string | null;
  function?: ToolCallFunction | null;
  index?: number | null;
  [k: string]: unknown;
}
export interface ToolCallFunction {
  name?: string | null;
  description?: string | null;
  arguments?: string;
  [k: string]: unknown;
}
export interface ResponseFormat {
  type: string;
  json_schema?: JSONSchema | null;
  [k: string]: unknown;
}
export interface JSONSchema {
  name?: string;
  strict?: boolean | null;
  schema: FunctionParameters;
  [k: string]: unknown;
}
export interface FunctionParameters {
  type?: string | null;
  description?: string | null;
  properties?: {
    [k: string]: Property;
  } | null;
  required?: string[];
  additionalProperties?: boolean | null;
  enum?: string[];
  [k: string]: unknown;
}
export interface Property {
  type?: string | string[];
  description?: string | null;
  items?: FunctionParameters | null;
  anyOf?: Property[] | null;
  enum?: string[];
  [k: string]: unknown;
}
export interface StreamOptions {
  include_usage?: boolean;
  [k: string]: unknown;
}
export interface Tool {
  type: string;
  function: Function;
  [k: string]: unknown;
}
export interface Function {
  name: string;
  description?: string | null;
  parameters?: FunctionParameters | null;
  strict?: boolean | null;
  [k: string]: unknown;
}
export interface ToolChoice {
  type: string;
  function?: Function | null;
  [k: string]: unknown;
}
export interface ChatCompletionAuth {
  openai_api_key?: string | null;
  groq_api_key?: string | null;
  override_api_key?: string | null;
  anthropic_api_key?: string | null;
  cerebras_api_key?: string | null;
  azure_api_key?: string | null;
  sambanova_api_key?: string | null;
  gemini_api_key?: string | null;
  deepseek_api_key?: string | null;
  [k: string]: unknown;
}
export interface KeyMap {
  openai_api_key?: Key | null;
  groq_api_key?: Key | null;
  anthropic_api_key?: Key | null;
  cerebras_api_key?: Key | null;
  azure_api_key?: Key | null;
  sambanova_api_key?: Key | null;
  gemini_api_key?: Key | null;
  deepseek_api_key?: Key | null;
  [k: string]: unknown;
}
export interface Key {
  id?: number | null;
  date_created?: number | null;
  key_value?: string | null;
  company_id?: number;
  description?: string;
  owner?: string;
  type?: string;
  obfuscated?: boolean;
  key_map?: KeyIdMap | null;
  [k: string]: unknown;
}
export interface KeyIdMap {
  openai_api_key?: number | null;
  groq_api_key?: number | null;
  anthropic_api_key?: number | null;
  cerebras_api_key?: number | null;
  azure_api_key?: number | null;
  sambanova_api_key?: number | null;
  gemini_api_key?: number | null;
  deepseek_api_key?: number | null;
  [k: string]: unknown;
}
export interface ClientParams {
  base_url?: string | null;
  default_headers?: {
    [k: string]: string;
  } | null;
  default_query?: {
    [k: string]: string;
  } | null;
  azure_params?: AzureParams | null;
  [k: string]: unknown;
}
export interface AzureParams {
  endpoint?: string | null;
  deployment?: string | null;
  api_version?: string | null;
  [k: string]: unknown;
}
export interface NormalizedLogProbs {
  tokens?: { token: string; confidence: number; alternatives?: { token: string; confidence: number }[] }[];
  mean_confidence?: number;
  min_confidence?: number;
  response_confidence?: number | null;
  low_confidence_pct?: number;
  low_confidence_threshold?: number;
  token_count?: number;
}
export interface ChatCompletionResponse {
  id?: string | number | null;
  object?: string;
  created?: number;
  model?: string;
  system_fingerprint?: string | null;
  choices?: ChatCompletionChoice[];
  usage?: ChatCompletionUsage | null;
  request_id?: string | null;
  evaluate_response?: EvaluateResponse | null;
  correction_applied?: boolean;
  first_token_time?: number;
  response_time?: number;
  chat_completion_request?: ChatCompletionRequest | null;
  service_tier?: string | null;
  input_safety_score?: number | null;
  fallback_reason?: string | null;
  normalized_logprobs?: NormalizedLogProbs | null;
}
export interface ChatCompletionChoice {
  index?: number | null;
  message?: ChatCompletionMessage;
  logprobs?: LogProbs | null;
  finish_reason?: string | null;
  is_correction?: boolean;
  [k: string]: unknown;
}
export interface ChatCompletionMessage {
  role: string;
  content?:
    | string
    | {
        [k: string]: unknown;
      }[]
    | null;
  function_call?: FunctionCall | null;
  tool_calls?: ToolCall[] | null;
  refusal?: string | null;
  [k: string]: unknown;
}
export interface FunctionCall {
  arguments?: string | null;
  name?: string | null;
  [k: string]: unknown;
}
export interface LogProbs {
  content?: LogPropsContent[];
  refusal?: LogPropsContent[];
  [k: string]: unknown;
}
export interface LogPropsContent {
  token: string;
  logprob: number;
  bytes?: number[];
  top_logprobs?: TopLogProbs[];
  [k: string]: unknown;
}
export interface TopLogProbs {
  token: string;
  logprob: number;
  bytes?: number[];
  [k: string]: unknown;
}
export interface ChatCompletionUsage {
  prompt_tokens?: number;
  completion_tokens?: number;
  total_tokens?: number;
  cost?: number;
  model?: string;
  completion_tokens_details?: CompletionTokensDetails | null;
  [k: string]: unknown;
}
export interface CompletionTokensDetails {
  reasoning_tokens?: number | null;
  [k: string]: unknown;
}
export interface EvaluateResponse {
  application_id?: number | null;
  session_id?: string | null;
  request_id?: string | null;
  evaluation_results?: EvaluateResult[];
  evaluation_request_id?: string | null;
  evaluate_summary?: string | null;
  evaluation_time?: number | null;
  reference_id?: string | number | null;
  id?: number | null;
  date_created?: number | null;
  correction?: string | null;
  meta?: {
    [k: string]: unknown;
  };
  [k: string]: unknown;
}
export interface EvaluateResult {
  id?: number | null;
  status?: string | null;
  description?: string | null;
  confidence?: number | null;
  meta?: {
    [k: string]: unknown;
  };
  sentinel_id?: number | null;
  eval_time?: number | null;
  date_created?: number | null;
  usage?: ChatCompletionUsage | null;
  sentinel_name?: string | null;
  severity?: number | null;
  correction?: string | null;
  sentinel_directive_id?: number | null;
  evaluation_request_id?: string | null;
  request_id?: string | null;
  application_id?: number | null;
  session_id?: string | null;
  [k: string]: unknown;
}
export interface EvaluateRequest {
  id?: number | null;
  date_created?: number | null;
  application_id?: number | null;
  application_ref_name?: string;
  session_id?: string;
  reference_id?: string | number | null;
  action_type?: string;
  evaluation_content_type?: EvaluationContentType | string;
  eval_results_set?: EvaluateResponse | null;
  company_id?: number | null;
  evaluation_context?: string | null;
  text_content?: string | null;
  message_content?: (ChatMessage | ChatCompletionMessage)[];
  request_id?: string | null;
  sentinel_id?: number | null;
  fault_description?: string | null;
  chat_completion_request?: ChatCompletionRequest | null;
  chat_completion_response?: ChatCompletionResponse | null;
  timeout?: number;
  partial?: string | null;
  stream?: boolean | null;
  apply_corrections?: boolean;
  timing_metrics?: RequestTimingMetric | null;
  tools?: Tool[];
  sentinels?: Sentinel[];
  evaluation_request_id?: string;
  json_schema?: JSONSchema | null;
  evaluation_run_id?: number | null;
}
export interface RequestTimingMetric {
  time_request_start: number;
  time_pre_request?: number;
  time_first_chunk?: number;
  time_request_end?: number;
  request_id?: string;
  [k: string]: unknown;
}
export interface Sentinel {
  sentinel_name: string;
  action_types?: string[];
  severity: SeverityLevel | number;
  meta?: {
    [k: string]: unknown;
  };
  qa?: SentinelQa[];
  id?: number | null;
  application_id?: number | null;
  date_created?: number | null;
  sentinel_directive?: SentinelDirective | null;
  state?: string | null;
  sentinel_generation_id?: number | null;
  intent_group_id?: number | null;
  sentinel_type?: string | null;
}
export interface SentinelQa {
  question: string;
  answer: string;
  [k: string]: unknown;
}
export interface SentinelDirective {
  id?: number | null;
  sentinel_id?: number | null;
  date_created?: number | null;
  directive_body: DirectiveBody;
  examples?: SentinelExample[];
  [k: string]: unknown;
}
export interface DirectiveBody {
  main?: string | null;
  override?: string | null;
  [k: string]: unknown;
}
export interface SentinelExample {
  example_type: string;
  example_body: string;
  [k: string]: unknown;
}
export interface EvaluationRun {
  id?: number | null;
  company_id?: number;
  application_id: number;
  intent_id: number;
  application: Application;
  intent: ApplicationAction;
  date_created?: number | null;
  date_start: number;
  date_end: number;
  sentinels?: Sentinel[];
  status: string;
  meta?: {
    [k: string]: unknown;
  };
  request_count: number;
  requests?: EvaluateRequest[];
}
export interface IntentGroup {
  id?: number | null;
  date_created?: number | null;
  company_id: number;
  intent_name: string;
  config?: Config | null;
  metadata?: {
    [k: string]: unknown;
  };
  last_activity?: number | null;
  request_count?: number | null;
}
export enum EvaluationType {
  EXACT_MATCH = "EXACT_MATCH",
  CONTAINS = "CONTAINS",
  BLEU = "BLEU",
  ROUGE = "ROUGE",
  COSINE_SIMILARITY = "COSINE_SIMILARITY",
  LEVENSHTEIN = "LEVENSHTEIN",
  LLM_JUDGE = "LLM_JUDGE",
}

export enum EvaluationFramework {
  MAITAI_CLASSIC = "MAITAI_CLASSIC",
  G_EVAL = "G_EVAL",
  RAGAS = "RAGAS",
  FLASK = "FLASK",
  CUSTOM = "CUSTOM",
}

export interface EvaluationCriteria {
  id?: number | null;
  company_id?: number;
  name: string;
  type?: EvaluationType | null;
  framework?: EvaluationFramework | null;
  instructions?: string | null;
  config?: { [k: string]: unknown };
  eval_model_config?: Config | null;
  is_system?: boolean;
  active?: boolean;
  date_created?: number | null;
}

export interface DeterministicCatalogEntry {
  type: string;
  name: string;
  description: string;
  config?: { [k: string]: unknown };
}

export interface FrameworkCriterionEntry {
  name: string;
  description: string;
}

export interface FrameworkCatalogEntry {
  id: string;
  name: string;
  description: string;
  criteria: FrameworkCriterionEntry[];
}

export interface AvailableCatalog {
  deterministic: DeterministicCatalogEntry[];
  frameworks: FrameworkCatalogEntry[];
}

export interface QualitativeEvaluationResult {
  id?: number | null;
  test_run_request_id: number;
  criteria: string;
  score: string;
  score_value: number;
  description?: string | null;
  date_created?: number | null;
  evaluation_criteria_id?: number | null;
  numeric_score?: number | null;
}
export interface ScoreCount {
  score: number;
  count: number;
  label?: string | null;
}
export interface TestRun {
  id?: number | null;
  test_set_id: number;
  company_id?: number;
  application_id?: number | null;
  application_action_id?: number | null;
  date_created?: number | null;
  date_completed?: number | null;
  description?: string | null;
  status?: string | null;
  config: Config;
  meta?: {
    [k: string]: unknown;
  };
  qualitative_evaluation_summary?: TestRunQualitativeEvaluationSummary | null;
  intent_group_id?: number | null;
}
export interface CriterionBreakdown {
  criteria_id?: number | null;
  criteria_name: string;
  criteria_type: string;
  scoring_type?: string;
  scoring_config?: { [k: string]: unknown };
  total_evaluated: number;
  pass_count: number;
  fail_count: number;
  avg_numeric_score?: number | null;
  score_distribution?: ScoreCount[];
}
export interface TestRunQualitativeEvaluationSummary {
  total_requests: number;
  completed_requests: number;
  error_requests: number;
  exact_match_count?: number;
  request_scores?: ScoreCount[];
  response_time_percentiles?: {
    [k: string]: number;
  };
  criteria_breakdowns?: CriterionBreakdown[];
}
export interface TestRunRequest {
  id?: number | null;
  company_id?: number;
  test_run_id: number;
  test_set_id: number;
  chat_completion_request_test_id: number;
  date_created?: number | null;
  date_executed?: number | null;
  request_id?: string | null;
  request?: ChatCompletionRequest | null;
  status?: string | null;
  original_request_id?: string | null;
  original_request?: ChatCompletionRequest | null;
  response?: ChatCompletionResponse | null;
  qualitative_evaluation_results?: QualitativeEvaluationResult[];
}
export interface TestSet {
  id?: number | null;
  name: string;
  company_id?: number;
  application_id?: number | null;
  application_action_id?: number | null;
  action_type?: string | null;
  meta?: {
    [k: string]: unknown;
  };
  date_created?: number | null;
  description?: string | null;
  is_golden?: boolean;
  intent_group_id?: number | null;
  intent_group?: IntentGroup | null;
}
